// TODO: Move items from management.js to this file.
import { company_name } from "@/i18n/variables";

const page = {
	password_tile: {
		credentials_saved_button: "Ich habe die Daten gespeichert.",
		description:
			"Die Anmeldedaten für Ihren VPS werden <strong>30 Tage lang</strong> im Passwort-Tresor gespeichert. Speichern Sie diese Daten in Ihrem eigenen Passwort-Manager.",
		description_completed: `Die Anmeldedaten aus dem Passwort-Tresor haben Sie in Ihrem Passwort-Manager gespeichert. Wenn Sie Ihr Passwort nicht gespeichert haben, wenden Sie sich bitte an ${company_name}.`,
		password_vault_button: "Zum Passwort-Tresor",
		title: "Anmeldedaten",
	},
};

const manage = {
	page: page,
};

export default manage;
